import axios from 'axios';

const api = axios.create({
  baseURL: '/api/v1',
  headers: {
    Authorization: `Bearer ${localStorage.getItem('@mrp-system:token')}`,
  },
});

api.interceptors.request.use((config) => {
  if (config?.headers) {
    config.headers.Authorization = `Bearer ${localStorage.getItem('@mrp-system:token')}`;
  }

  return config;
});

export default api;
